export default __webpack_public_path__ + "static/illustration-right-b764eb75f0d0fe0d6199501737deaae1.png";